/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { upperFirst } from 'lodash'
import { useIntl } from 'react-intl'
import FormField, {
  FormTextFieldProps
} from '../../../../client/js/components/form/fields/FormField'

function FirstNameField (props: FormTextFieldProps) {
  const { name = 'firstName', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      // autoComplete="given-name"
      label={intl.formatMessage({
        id: 'firstName',
        defaultMessage: 'Prénom'
      })}
      name={name}
      parser={upperFirst}
      {...others}
    />
  )
}

export default FirstNameField
